const customMapper = {
    skipDefaultMapping: true,
    mapper: {
        // hack to get around the fact that page events are sent by default by redux-segment for all these actions
        "@@router/INIT_PATH": undefined,
        "@@router/UPDATE_PATH": undefined,
        "@@router/LOCATION_CHANGE": undefined,
        "@@reduxReactRouter/initRoutes": undefined,
        "@@reduxReactRouter/routerDidChange": undefined,
        "@@reduxReactRouter/replaceRoutes": undefined,
    },
};

export { customMapper };
